module.exports = __webpack_public_path__ + "img/background8.3ac6fcc6.jpg";